<mat-checkbox
    [formControl]="castedControl"
    [color]="color"
    [id]="tagId"
    [required]="isRequired"
    [indeterminate]="isIndeterminate"
    [labelPosition]="showLabelInFront ? 'before' : 'after'">
    {{ label || (labelKey | transloco) }}
</mat-checkbox>
